import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import {Provider} from "react-redux";
import store from './reduxStore/store';

ReactDOM.render(
  <BrowserRouter>
      <Provider store={store}><App /></Provider>
  </BrowserRouter>,
  document.getElementById('root')
);


